import React from "react"

interface DateSeparatorProps {
  monthYear: string
}

/**
 * DateSeparator component for displaying a separator with month and year.
 * Renders the provided month and year along with a separator line.
 */
const DateSeparator: React.FC<DateSeparatorProps> = ({ monthYear }) => {
  return (
    <div className="flex items-center gap-8 py-2 pl-2">
      <div className="text-sm text-neutral-500">{monthYear}</div>
      <div className="h-px flex-grow bg-neutral-400" />
    </div>
  )
}

export default DateSeparator
